import { Component, Input } from '@angular/core'
import { LocalesType } from '@app/shared/data-types/locales.types'
import { SubdomainLinkTypes } from '@app/shared/directives/subdomain-link/subdomain-link.directive'
import { LocalesService } from '@app/shared/services/locales'

@Component({
  selector: 'registration-footer',
  templateUrl: './registration-footer.component.html',
  styleUrls: ['./registration-footer.component.scss'],
  standalone: false,
})
export class RegistrationFooterComponent {
  @Input() isHideNavigation: boolean
  constructor(public localesService: LocalesService) {}
  locales = LocalesType
  subdomainLinksTypes = SubdomainLinkTypes

  setLocale(locale: LocalesType): void {
    this.localesService.set(locale).subscribe(() => window.location.reload())
  }
}
